var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.046 5.037c.497-2.05 3.411-2.05 3.908 0a2.01 2.01 0 003.002 1.243c1.8-1.096 3.862.964 2.765 2.765a2.013 2.013 0 001.242 3c2.05.498 2.05 3.412 0 3.91a2.01 2.01 0 00-1.243 3.001c1.097 1.8-.964 3.862-2.765 2.765a2.012 2.012 0 00-3 1.242c-.498 2.05-3.412 2.05-3.91 0a2.01 2.01 0 00-3.001-1.243c-1.8 1.097-3.862-.964-2.765-2.765a2.01 2.01 0 00-1.242-3c-2.05-.498-2.05-3.412 0-3.91A2.01 2.01 0 006.28 9.045c-1.096-1.8.964-3.862 2.765-2.765a2.01 2.01 0 003-1.242z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0v0z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default __webpack_public_path__ + "static/media/cog.19956718.svg";
export { SvgCog as ReactComponent };